module.exports = __webpack_public_path__ + "images/f4351e885047d7793f01404ba82e8a11.svg";